import SnackbarWarper from '@/components/common/SnackbarWarper/SnackbarWarper';
import { DataContextProvider } from '@/context/DataContext';
import { Route as RouteType } from '@sm-dashboard/types';
import TitleUpdater from '@/components/common/TitleUpdater';

interface RouteWrapperProps {
  route: RouteType;
}

const RouteWrapper = ({ route }: RouteWrapperProps) => {
  if (route.isPublic) {
    // Public routes don't need the dashboard layout
    return (
      <>
        <TitleUpdater isPublic={true} />
        {route.element}
        <SnackbarWarper />
      </>
    );
  }

  // Private routes get wrapped with data context and dashboard layout
  return (
    <DataContextProvider>
      <TitleUpdater />
      {route.element}
      <SnackbarWarper />
    </DataContextProvider>
  );
};

export default RouteWrapper;
